import axios from 'axios'
import { apiPaths } from 'src/core/urlTree'
import { useCustomAxios } from 'src/hook/axios/useCustomAxios'
import { IPatientDetail } from 'src/models/interfaces'
import { IResBase } from 'src/services/base'
import { IDebtSettlementDto, IEditPatientDto, IGetPatientByCustomIdDto, IParamsGetPatients, IUpdatePatientInsuranceDto } from './interfaces'
import { IResDataPatientsList } from './interfaces'
import { IAddPatientDto } from './interfaces/AddPatient'
import { IGetPatientBalanceDto } from './interfaces/GetPatientBalance'
import { IGetPatientVisitSummaryDto } from './interfaces/GetPatientVisitSummary'
import { IPatientService } from './interfaces/PatientService'
import { fixArabicText } from 'src/helper/fixArabicText'
import { IAddPatientAnonymousDto } from './interfaces/addpatientAnonymous/addPatientAnonymousDto'

export const PatientServices = (): IPatientService => {
  const { customAxios } = useCustomAxios()

  const getPatients = async (params: IParamsGetPatients) => {
    const response = await axios.get<IResBase<IResDataPatientsList>>(apiPaths.GetPatients, { params })

    return response.data
  }
  const getPatientsById = async (id: number) => {
    const response = await axios.get<IResBase<IPatientDetail>>(`Patient/GetPatient/${id}`)

    return response.data
  }

  const GetPatientByNationalCodeAsync = async (nationalCode: string) => {
    const response = await customAxios.get(`Patient/GetPatientByNationalCode/${nationalCode}`)

    return response.data
  }

  const GetPatientByArchiveCodeAsync = async (archiveCode: string) => {
    const response = await axios.get(`Patient/GetPatientByArchiveCode/${archiveCode}`)

    return response.data
  }
  const GetPatientByCustomIdAsync = async (params: IGetPatientByCustomIdDto) => {
    const response = await axios.get('Patient/GetPatientByCustomId', { params })

    return response.data
  }

  const AddPatientAsync = async (params: IAddPatientDto) => {

    params.user.firstName = fixArabicText(params.user.firstName);
    params.user.lastName = fixArabicText(params.user.lastName);

    const response = await axios.post('Patient/AddPatient', params)

    return response.data
  }

  const GetPatientVisitSummaryAsync = async (params: IGetPatientVisitSummaryDto) => {
    const response = await axios.get('Patient/GetPatientVisitSummary', { params })

    return response.data
  }
  const GetPatientBalanceAsync = async (params: IGetPatientBalanceDto) => {
    const response = await axios.get(`Patient/GetPatientBalance/${params.patientId}`, {
      params: {
        clinicId: params.clinicId,
        officeId: params.officeId,
      },
    })

    return response.data
  }

  const EditPatientAsync = async (params: IAddPatientDto) => {

    params.user.firstName = fixArabicText(params.user.firstName);
    params.user.lastName = fixArabicText(params.user.lastName);

    const response = await axios.put(`Patient/EditPatient/${params.patient.id}`, params)

    return response.data
  }
  const UpdatePatientInsuranceAsync = async (params: IUpdatePatientInsuranceDto) => {
    const response = await axios.put(`Patient/UpdatePatientInsurance/${params.patientId}`, params)

    return response.data
  }
  const DebtSettlementAsync = async (params: IDebtSettlementDto) => {
    const response = await axios.post('Patient/DebtSettlement', params)

    return response.data
  }
  const DeletePatientAsync = async (patientId: number) => {
    const response = await axios.delete(`Patient/DeletePatient/${patientId}`)

    return response.data
  }

  const AddPatientAnonymousAsync =async (params: IAddPatientAnonymousDto) => {

    const response = await axios.post('Patient/AddPatinet/Anonymous', params)

    return response.data
  }

  return {
    getPatients,
    getPatientsById,
    GetPatientByNationalCodeAsync,
    AddPatientAsync,
    GetPatientByArchiveCodeAsync,
    GetPatientVisitSummaryAsync,
    GetPatientBalanceAsync,
    GetPatientByCustomIdAsync,
    EditPatientAsync,
    UpdatePatientInsuranceAsync,
    DebtSettlementAsync,
    DeletePatientAsync,
    AddPatientAnonymousAsync
  }
}
